
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const vissionSlice = createSlice({
    name: 'vissions',
    loading: false,
    initialState: {
        vissionlist: [],
        vissionCount: 0
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.vissionlist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.vissionlist = action.payload.data?action.payload.data:[];
            state.vissionCount = action.payload.count || 0
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = vissionSlice.actions;
//console.log(body);

export const fetchVissions = (body)=> apiCallBegan({
    url: '/mission-vision/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});













